import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link, useParams } from 'react-router-dom';

import { useSubscriptions } from '../hooks/useSubscriptions.ts';
import { useSubscriptionsSelection } from '../hooks/useSubscriptionsSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Subscription } from '../types';

export const RecordsTable = () => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useSubscriptions();

    const { selectedRecords, setSelectedRecords } = useSubscriptionsSelection();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Subscription>[] = [
        {
            accessor: 'customer',
            title: 'Subscription',
            render: (record: Subscription) => {
                const { id: customerId } = useParams();
                const customerName = record.customer?.name || record.customerId;
                const itemCount = record.items?.length || 0;
                const displayText = itemCount > 0
                    ? `${customerName} (${itemCount} item${itemCount > 1 ? 's' : ''})`
                    : customerName;

                return (
                    <Link to={`/customers/${customerId}/subscriptions/${record.id}`} style={{ textDecoration: 'none' }}>
                        <Text c="blue" style={{ cursor: 'pointer' }}>
                            {displayText}
                        </Text>
                    </Link>
                );
            }
        },
        {
            accessor: 'status',
            title: 'Status'
        },
        {
            accessor: 'created',
            title: 'Created'
        },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items as Subscription[]}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};